import { render, staticRenderFns } from "./newList.vue?vue&type=template&id=64ef3332&scoped=true&"
import script from "./newList.vue?vue&type=script&lang=ts&"
export * from "./newList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef3332",
  null
  
)

export default component.exports